/* eslint-disable no-useless-catch */
import { getBarcodeProcesses } from '@/utils/api'
import { showErrorMessage } from '@/utils/helpers'

import {
  LOAD_BARCODE_PROCESS_LIST,
  CLEAR_ALL,
  SET_BARCODE_PROCESS_LOADING,
  CLEAR_BARCODE_PROCESS_LOADING,
} from './actions'
import { IBarcodeProcessList, IBarcodeProcess, IBarcodeProcessSearchPayload } from '@/utils/types'

type TBarcodeProcessStates = {
  isLoaded: boolean
  totalBarcodes: number
  barcodeProcesses: Array<IBarcodeProcessList>
  barcodeProcess: IBarcodeProcess
  loading: boolean
}

export default {
  state: {
    isLoaded: false,
    totalBarcodes: 0,
    barcodeProcesses: [],
    barcodeProcess: {} as IBarcodeProcess,
    loading: false,
  },
  mutations: {
    [LOAD_BARCODE_PROCESS_LIST]: (
      state: TBarcodeProcessStates,
      {
        barcodeProcesses,
        totalBarcodes,
      }: {
        barcodeProcesses: Array<IBarcodeProcessList>
        totalBarcodes: number
      }
    ) => {
      state.isLoaded = true
      state.barcodeProcesses = barcodeProcesses
      state.totalBarcodes = totalBarcodes
    },
    [SET_BARCODE_PROCESS_LOADING]: (state: TBarcodeProcessStates) => {
      state.loading = true
    },
    [CLEAR_BARCODE_PROCESS_LOADING]: (state: TBarcodeProcessStates) => {
      state.loading = false
    },
    [CLEAR_ALL]: (state: TBarcodeProcessStates) => {
      state.isLoaded = false
      state.barcodeProcesses = []
      state.barcodeProcess = {} as IBarcodeProcess
    },
  },
  actions: {
    [LOAD_BARCODE_PROCESS_LIST]: async (
      {
        commit,
      }: {
        commit: Function
      },
      data: IBarcodeProcessSearchPayload
    ) => {
      let result
      try {
        commit(SET_BARCODE_PROCESS_LOADING)
        result = await getBarcodeProcesses(data)
        commit(LOAD_BARCODE_PROCESS_LIST, {
          barcodeProcesses: result.barcodeProcesses,
          totalBarcodes: result.count,
        })
      } catch (err) {
        switch (err) {
          case '2310':
            break
          default:
            showErrorMessage(err as string, data.t, data.te)
            break
        }
        commit(LOAD_BARCODE_PROCESS_LIST, {
          barcodeProcesses: [],
          totalBarcodes: 0,
        })
      } finally {
        commit(CLEAR_BARCODE_PROCESS_LOADING)
      }
    },
  },
}
